"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Box = _interopRequireDefault(require("@commerce-ui/core2/Box"));
var _Grid = _interopRequireDefault(require("@commerce-ui/core2/Grid"));
var __jsx = _react["default"].createElement;
var RectangleCardWithLabelInsideSection = function RectangleCardWithLabelInsideSection(_ref) {
  var rectangleCards = _ref.rectangleCards;
  return __jsx(_Grid["default"], {
    cols: [2, null, 4, null]
  }, rectangleCards.map(function (rectangleCard, index) {
    return __jsx(_Box["default"], {
      key: index
    }, rectangleCard);
  }));
};
var _default = RectangleCardWithLabelInsideSection;
exports["default"] = _default;